<!-- <app-notification></app-notification> -->
<div id="bg">
  <img src="/assets/images/login-background.png" alt="" />
  <div class="centered">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="card">
        <h3 class="login">Login</h3>
        <mat-form-field class="log">
          <input
            id="username"
            formControlName="userid"
            matInput
            placeholder="USER NAME"
            class="username"
          />
        </mat-form-field>
        <mat-form-field class="log">
          <input
            id="password"
            formControlName="password"
            matInput
            placeholder="PASSWORD"
            class="password"
            type="password"
          />
        </mat-form-field>
        <div class="flex">
          <mat-checkbox labelPosition="after" class="rememberme"
            >Remember Me</mat-checkbox
          >
          <a class="forgot" routerLink="/forgot-password">Forgot Password?</a>
        </div>
        <div>
          <button id="btn-primary" mat-flat-button class="submit">
            SUBMIT
          </button>
        </div>
        <mat-error *ngIf="error !== ''" class="error" data-cy="login-error">{{
          error
        }}</mat-error>
      </div>
    </form>
  </div>
</div>
